import { t as e } from "./dist-DAt3we1k.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
import * as r from "react-dom";
//#region ../../node_modules/.pnpm/@radix-ui+react-compose-refs@1.1.5_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var i = Object.defineProperty, a = (e, t) => i(e, "name", {
	value: t,
	configurable: !0
});
function o(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
a(o, "setRef");
function s(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = o(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : o(e[t], null);
			}
		};
	};
}
a(s, "composeRefs");
function c(...e) {
	return t.useCallback(s(...e), e);
}
a(c, "useComposedRefs");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-context@1.2.2_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-context/dist/index.mjs
var l = Object.defineProperty, u = (e, t) => l(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function d(e, r) {
	let i = t.createContext(r);
	i.displayName = e + "Context";
	let a = /* @__PURE__ */ u((e) => {
		let { children: r, ...a } = e, o = t.useMemo(() => a, Object.values(a));
		return /* @__PURE__ */ n(i.Provider, {
			value: o,
			children: r
		});
	}, "Provider");
	a.displayName = e + "Provider";
	function o(n, a = {}) {
		let { optional: o = !1 } = a, s = t.useContext(i);
		if (s) return s;
		if (r !== void 0) return r;
		if (!o) throw Error(`\`${n}\` must be used within \`${e}\``);
	}
	return u(o, "useContext"), [a, o];
}
u(d, "createContext");
// @__NO_SIDE_EFFECTS__
function f(e, r = []) {
	let i = [];
	function a(r, a) {
		let o = t.createContext(a);
		o.displayName = r + "Context";
		let s = i.length;
		i = [...i, a];
		let c = /* @__PURE__ */ u((r) => {
			let { scope: i, children: a, ...c } = r, l = i?.[e]?.[s] || o, u = t.useMemo(() => c, Object.values(c));
			return /* @__PURE__ */ n(l.Provider, {
				value: u,
				children: a
			});
		}, "Provider");
		c.displayName = r + "Provider";
		function l(n, i, c = {}) {
			let { optional: l = !1 } = c, u = i?.[e]?.[s] || o, d = t.useContext(u);
			if (d) return d;
			if (a !== void 0) return a;
			if (!l) throw Error(`\`${n}\` must be used within \`${r}\``);
		}
		return u(l, "useContext"), [c, l];
	}
	u(a, "createContext");
	let o = /* @__PURE__ */ u(() => {
		let n = i.map((e) => t.createContext(e));
		return /* @__PURE__ */ u(function(r) {
			let i = r?.[e] || n;
			return t.useMemo(() => ({ [`__scope${e}`]: {
				...r,
				[e]: i
			} }), [r, i]);
		}, "useScope");
	}, "createScope");
	return o.scopeName = e, [a, p(o, ...r)];
}
u(f, "createContextScope");
function p(...e) {
	let n = e[0];
	if (e.length === 1) return n;
	let r = /* @__PURE__ */ u(() => {
		let r = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ u(function(e) {
			let i = r.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return t.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return r.scopeName = n.scopeName, r;
}
u(p, "composeContextScopes");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.3.3_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-slot/dist/index.mjs
var m = Object.defineProperty, h = (e, t) => m(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function g(e) {
	let n = t.forwardRef((n, r) => {
		let { children: i, ...a } = n, o = null, s = !1, l = [];
		w(i) && typeof D == "function" && (i = D(i._payload)), t.Children.forEach(i, (e) => {
			if (S(e)) {
				s = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				w(n) && typeof D == "function" && (n = D(n._payload)), o = y(t, n), l.push(o?.props?.children);
			} else l.push(e);
		}), o ? o = t.cloneElement(o, void 0, l) : !s && t.Children.count(i) === 1 && t.isValidElement(i) && (o = i);
		let u = o ? x(o) : void 0, d = c(r, u);
		if (!o) {
			if (i || i === 0) throw Error(s ? E(e) : ee(e));
			return i;
		}
		let f = b(a, o.props ?? {});
		return o.type !== t.Fragment && (f.ref = r ? d : u), t.cloneElement(o, f);
	});
	return n.displayName = `${e}.Slot`, n;
}
h(g, "createSlot");
var _ = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function v(e) {
	let t = /* @__PURE__ */ h((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = _, t;
}
h(v, "createSlottable");
var y = /* @__PURE__ */ h((e, n) => {
	if ("child" in e.props) {
		let n = e.props.child;
		return t.isValidElement(n) ? t.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
	}
	return t.isValidElement(n) ? n : null;
}, "getSlottableElementFromSlottable");
function b(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
h(b, "mergeProps");
function x(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
h(x, "getElementRef");
function S(e) {
	return t.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === _;
}
h(S, "isSlottable");
var C = Symbol.for("react.lazy");
function w(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === C && "_payload" in e && T(e._payload);
}
h(w, "isLazyComponent");
function T(e) {
	return typeof e == "object" && !!e && "then" in e;
}
h(T, "isPromiseLike");
var ee = /* @__PURE__ */ h((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), E = /* @__PURE__ */ h((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), D = t.use, te = Object.defineProperty, ne = (e, t) => te(e, "name", {
	value: t,
	configurable: !0
}), O = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, r) => {
	let i = /* @__PURE__ */ g(`Primitive.${r}`), a = t.forwardRef((e, t) => {
		let { asChild: a, ...o } = e, s = a ? i : r;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ n(s, {
			...o,
			ref: t
		});
	});
	return a.displayName = `Primitive.${r}`, {
		...e,
		[r]: a
	};
}, {});
function re(e, t) {
	e && r.flushSync(() => e.dispatchEvent(t));
}
ne(re, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-collection@1.1.15_@types+react-dom@19.2.3_@types+react@19.2.17__@types+_a6e002053e9d39acf9bcc3523eca26cd/node_modules/@radix-ui/react-collection/dist/index.mjs
var ie = Object.defineProperty, k = (e, t) => ie(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function A(e) {
	let r = e + "CollectionProvider", [i, a] = /* @__PURE__ */ f(r), [o, s] = i(r, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), l = /* @__PURE__ */ k((e) => {
		let { scope: r, children: i } = e, a = t.useRef(null), s = t.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ n(o, {
			scope: r,
			itemMap: s,
			collectionRef: a,
			children: i
		});
	}, "CollectionProvider");
	l.displayName = r;
	let u = e + "CollectionSlot", d = /* @__PURE__ */ g(u), p = t.forwardRef((e, t) => {
		let { scope: r, children: i } = e, a = c(t, s(u, r).collectionRef);
		return /* @__PURE__ */ n(d, {
			ref: a,
			children: i
		});
	});
	p.displayName = u;
	let m = e + "CollectionItemSlot", h = "data-radix-collection-item", _ = /* @__PURE__ */ g(m), v = t.forwardRef((e, r) => {
		let { scope: i, children: a, ...o } = e, l = t.useRef(null), u = c(r, l), d = s(m, i);
		return t.useEffect(() => (d.itemMap.set(l, {
			ref: l,
			...o
		}), () => void d.itemMap.delete(l))), /* @__PURE__ */ n(_, {
			[h]: "",
			ref: u,
			children: a
		});
	});
	v.displayName = m;
	function y(n) {
		let r = s(e + "CollectionConsumer", n);
		return t.useCallback(() => {
			let e = r.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${h}]`));
			return Array.from(r.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [r.collectionRef, r.itemMap]);
	}
	return k(y, "useCollection"), [
		{
			Provider: l,
			Slot: p,
			ItemSlot: v
		},
		y,
		a
	];
}
k(A, "createCollection");
var ae = /* @__PURE__ */ new WeakMap(), j = class e extends Map {
	static {
		k(this, "OrderedDict");
	}
	#e;
	constructor(e) {
		super(e), this.#e = [...super.keys()], ae.set(this, !0);
	}
	set(e, t) {
		return ae.get(this) && (this.has(e) ? this.#e[this.#e.indexOf(e)] = e : this.#e.push(e)), super.set(e, t), this;
	}
	insert(e, t, n) {
		let r = this.has(t), i = this.#e.length, a = N(e), o = a >= 0 ? a : i + a, s = o < 0 || o >= i ? -1 : o;
		if (s === this.size || r && s === this.size - 1 || s === -1) return this.set(t, n), this;
		let c = this.size + +!r;
		a < 0 && o++;
		let l = [...this.#e], u, d = !1;
		for (let e = o; e < c; e++) if (o === e) {
			let i = l[e];
			l[e] === t && (i = l[e + 1]), r && this.delete(t), u = this.get(i), this.set(t, n);
		} else {
			!d && l[e - 1] === t && (d = !0);
			let n = l[d ? e : e - 1], r = u;
			u = this.get(n), this.delete(n), this.set(n, r);
		}
		return this;
	}
	with(t, n, r) {
		let i = new e(this);
		return i.insert(t, n, r), i;
	}
	before(e) {
		let t = this.#e.indexOf(e) - 1;
		if (!(t < 0)) return this.entryAt(t);
	}
	setBefore(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r, t, n);
	}
	after(e) {
		let t = this.#e.indexOf(e);
		if (t = t === -1 || t === this.size - 1 ? -1 : t + 1, t !== -1) return this.entryAt(t);
	}
	setAfter(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r + 1, t, n);
	}
	first() {
		return this.entryAt(0);
	}
	last() {
		return this.entryAt(-1);
	}
	clear() {
		return this.#e = [], super.clear();
	}
	delete(e) {
		let t = super.delete(e);
		return t && this.#e.splice(this.#e.indexOf(e), 1), t;
	}
	deleteAt(e) {
		let t = this.keyAt(e);
		return t !== void 0 && this.delete(t);
	}
	at(e) {
		let t = M(this.#e, e);
		if (t !== void 0) return this.get(t);
	}
	entryAt(e) {
		let t = M(this.#e, e);
		if (t !== void 0) return [t, this.get(t)];
	}
	indexOf(e) {
		return this.#e.indexOf(e);
	}
	keyAt(e) {
		return M(this.#e, e);
	}
	from(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.at(r);
	}
	keyFrom(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.keyAt(r);
	}
	find(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return r;
			n++;
		}
	}
	findIndex(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return n;
			n++;
		}
		return -1;
	}
	filter(t, n) {
		let r = [], i = 0;
		for (let e of this) Reflect.apply(t, n, [
			e,
			i,
			this
		]) && r.push(e), i++;
		return new e(r);
	}
	map(t, n) {
		let r = [], i = 0;
		for (let e of this) r.push([e[0], Reflect.apply(t, n, [
			e,
			i,
			this
		])]), i++;
		return new e(r);
	}
	reduce(...e) {
		let [t, n] = e, r = 0, i = n ?? this.at(0);
		for (let n of this) i = r === 0 && e.length === 1 ? n : Reflect.apply(t, this, [
			i,
			n,
			r,
			this
		]), r++;
		return i;
	}
	reduceRight(...e) {
		let [t, n] = e, r = n ?? this.at(-1);
		for (let n = this.size - 1; n >= 0; n--) {
			let i = this.at(n);
			r = n === this.size - 1 && e.length === 1 ? i : Reflect.apply(t, this, [
				r,
				i,
				n,
				this
			]);
		}
		return r;
	}
	toSorted(t) {
		let n = [...this.entries()].sort(t);
		return new e(n);
	}
	toReversed() {
		let t = new e();
		for (let e = this.size - 1; e >= 0; e--) {
			let n = this.keyAt(e), r = this.get(n);
			t.set(n, r);
		}
		return t;
	}
	toSpliced(...t) {
		let n = [...this.entries()];
		return n.splice(...t), new e(n);
	}
	slice(t, n) {
		let r = new e(), i = this.size - 1;
		if (t === void 0) return r;
		t < 0 && (t += this.size), n !== void 0 && n > 0 && (i = n - 1);
		for (let e = t; e <= i; e++) {
			let t = this.keyAt(e), n = this.get(t);
			r.set(t, n);
		}
		return r;
	}
	every(e, t) {
		let n = 0;
		for (let r of this) {
			if (!Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !1;
			n++;
		}
		return !0;
	}
	some(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !0;
			n++;
		}
		return !1;
	}
};
function M(e, t) {
	if ("at" in Array.prototype) return Array.prototype.at.call(e, t);
	let n = oe(e, t);
	return n === -1 ? void 0 : e[n];
}
k(M, "at");
function oe(e, t) {
	let n = e.length, r = N(t), i = r >= 0 ? r : n + r;
	return i < 0 || i >= n ? -1 : i;
}
k(oe, "toSafeIndex");
function N(e) {
	return e !== e || e === 0 ? 0 : Math.trunc(e);
}
k(N, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function se(e) {
	let r = e + "CollectionProvider", [i, a] = /* @__PURE__ */ f(r), [o, s] = i(r, {
		collectionElement: null,
		collectionRef: { current: null },
		collectionRefObject: { current: null },
		itemMap: new j(),
		setItemMap: /* @__PURE__ */ k(() => void 0, "setItemMap")
	}), l = /* @__PURE__ */ k(({ state: e, ...t }) => e ? /* @__PURE__ */ n(d, {
		...t,
		state: e
	}) : /* @__PURE__ */ n(u, { ...t }), "CollectionProvider");
	l.displayName = r;
	let u = /* @__PURE__ */ k((e) => {
		let t = b();
		return /* @__PURE__ */ n(d, {
			...e,
			state: t
		});
	}, "CollectionInit");
	u.displayName = r + "Init";
	let d = /* @__PURE__ */ k((e) => {
		let { scope: r, children: i, state: a } = e, s = t.useRef(null), [l, u] = t.useState(null), d = c(s, u), [f, p] = a;
		return t.useEffect(() => {
			if (!l) return;
			let e = ue(() => {});
			return e.observe(l, {
				childList: !0,
				subtree: !0
			}), () => {
				e.disconnect();
			};
		}, [l]), /* @__PURE__ */ n(o, {
			scope: r,
			itemMap: f,
			setItemMap: p,
			collectionRef: d,
			collectionRefObject: s,
			collectionElement: l,
			children: i
		});
	}, "CollectionProviderImpl");
	d.displayName = r + "Impl";
	let p = e + "CollectionSlot", m = /* @__PURE__ */ g(p), h = t.forwardRef((e, t) => {
		let { scope: r, children: i } = e, a = c(t, s(p, r).collectionRef);
		return /* @__PURE__ */ n(m, {
			ref: a,
			children: i
		});
	});
	h.displayName = p;
	let _ = e + "CollectionItemSlot", v = /* @__PURE__ */ g(_), y = t.forwardRef((e, r) => {
		let { scope: i, children: a, ...o } = e, l = t.useRef(null), [u, d] = t.useState(null), f = c(r, l, d), { setItemMap: p } = s(_, i), m = t.useRef(o);
		ce(m.current, o) || (m.current = o);
		let h = m.current;
		return t.useEffect(() => {
			let e = h;
			return p((t) => u ? t.has(u) ? t.set(u, {
				...e,
				element: u
			}).toSorted(P) : (t.set(u, {
				...e,
				element: u
			}), t.toSorted(P)) : t), () => {
				p((e) => !u || !e.has(u) ? e : (e.delete(u), new j(e)));
			};
		}, [
			u,
			h,
			p
		]), /* @__PURE__ */ n(v, {
			"data-radix-collection-item": "",
			ref: f,
			children: a
		});
	});
	y.displayName = _;
	function b() {
		return t.useState(new j());
	}
	k(b, "useInitCollection");
	function x(t) {
		let { itemMap: n } = s(e + "CollectionConsumer", t);
		return n;
	}
	return k(x, "useCollection"), [{
		Provider: l,
		Slot: h,
		ItemSlot: y
	}, {
		createCollectionScope: a,
		useCollection: x,
		useInitCollection: b
	}];
}
k(se, "createCollection");
function ce(e, t) {
	if (e === t) return !0;
	if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r of n) if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
	return !0;
}
k(ce, "shallowEqual");
function le(e, t) {
	return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
k(le, "isElementPreceding");
function P(e, t) {
	return !e[1].element || !t[1].element ? 0 : le(e[1].element, t[1].element) ? -1 : 1;
}
k(P, "sortByDocumentPosition");
function ue(e) {
	return new MutationObserver((t) => {
		for (let n of t) if (n.type === "childList") {
			e();
			return;
		}
	});
}
k(ue, "getChildListObserver");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.4_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var F = globalThis?.document ? t.useLayoutEffect : () => {}, de = Object.defineProperty, fe = (e, t) => de(e, "name", {
	value: t,
	configurable: !0
}), pe = t.useId || (() => void 0), me = 0;
function I(e) {
	let [n, r] = t.useState(pe());
	return F(() => {
		e || r((e) => e ?? String(me++));
	}, [e]), e || (n ? `radix-${n}` : "");
}
fe(I, "useId");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-callback-ref@1.1.4_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var he = Object.defineProperty, ge = (e, t) => he(e, "name", {
	value: t,
	configurable: !0
});
function L(e) {
	let n = t.useRef(e);
	return t.useEffect(() => {
		n.current = e;
	}), t.useMemo(() => ((...e) => n.current?.(...e)), []);
}
ge(L, "useCallbackRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-effect-event@0.0.5_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var _e = Object.defineProperty, ve = (e, t) => _e(e, "name", {
	value: t,
	configurable: !0
}), R = t.useEffectEvent, z = t.useInsertionEffect;
function ye(e) {
	if (typeof R == "function") return R(e);
	let n = t.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof z == "function" ? z(() => {
		n.current = e;
	}) : F(() => {
		n.current = e;
	}), t.useMemo(() => ((...e) => n.current?.(...e)), []);
}
ve(ye, "useEffectEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-controllable-state@1.2.6_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var be = Object.defineProperty, B = (e, t) => be(e, "name", {
	value: t,
	configurable: !0
}), xe = t.useInsertionEffect || F;
function V({ prop: e, defaultProp: n, onChange: r = /* @__PURE__ */ B(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = Se({
		defaultProp: n,
		onChange: r
	}), c = e !== void 0;
	return [c ? e : a, t.useCallback((t) => {
		if (c) {
			let n = Ce(t) ? t(e) : t;
			n !== e && s.current?.(n);
		} else o(t);
	}, [
		c,
		e,
		o,
		s
	])];
}
B(V, "useControllableState");
function Se({ defaultProp: e, onChange: n }) {
	let [r, i] = t.useState(e), a = t.useRef(r), o = t.useRef(n);
	return xe(() => {
		o.current = n;
	}, [n]), t.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
B(Se, "useUncontrolledState");
function Ce(e) {
	return typeof e == "function";
}
B(Ce, "isFunction");
var we = Symbol("RADIX:SYNC_STATE");
function Te(e, n, r, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = n, l = a !== void 0, u = ye(s), d = [{
		...r,
		state: o
	}];
	i && d.push(i);
	let [f, p] = t.useReducer((t, n) => {
		if (n.type === we) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return l && !Object.is(r.state, t.state) && u(r.state), r;
	}, ...d), m = f.state, h = t.useRef(m);
	t.useEffect(() => {
		h.current !== m && (h.current = m, l || u(m));
	}, [
		m,
		h,
		l
	]);
	let g = t.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return t.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: we,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [g, p];
}
B(Te, "useControllableStateReducer");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-direction@1.1.4_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-direction/dist/index.mjs
var Ee = Object.defineProperty, De = (e, t) => Ee(e, "name", {
	value: t,
	configurable: !0
}), Oe = t.createContext(void 0);
function H(e) {
	let n = t.useContext(Oe);
	return e || n || "ltr";
}
De(H, "useDirection");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-is-hydrated@0.1.3_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-is-hydrated/dist/index.mjs
var ke = Object.defineProperty, U = (e, t) => ke(e, "name", {
	value: t,
	configurable: !0
}), W = !1;
function Ae() {
	let [e, n] = t.useState(W);
	return t.useEffect(() => {
		W || (W = !0, n(!0));
	}, []), e;
}
U(Ae, "useIsHydrated");
var je = t.useSyncExternalStore;
function Me() {
	return () => {};
}
U(Me, "subscribe");
function Ne() {
	return je(Me, () => !0, () => !1);
}
U(Ne, "useIsHydratedModern");
var Pe = typeof je == "function" ? Ne : Ae, Fe = Object.defineProperty, G = (e, t) => Fe(e, "name", {
	value: t,
	configurable: !0
}), K = "rovingFocusGroup.onEntryFocus", Ie = {
	bubbles: !1,
	cancelable: !0
}, q = "RovingFocusGroup", [J, Le, Re] = /* @__PURE__ */ A(q), [ze, Be] = /* @__PURE__ */ f(q, [Re]), [Ve, He] = ze(q), Ue = /* @__PURE__ */ t.forwardRef(/* @__PURE__ */ G(function(e, t) {
	return /* @__PURE__ */ n(J.Provider, {
		scope: e.__scopeRovingFocusGroup,
		children: /* @__PURE__ */ n(J.Slot, {
			scope: e.__scopeRovingFocusGroup,
			children: /* @__PURE__ */ n(We, {
				...e,
				ref: t
			})
		})
	});
}, "RovingFocusGroup")), We = /* @__PURE__ */ t.forwardRef(/* @__PURE__ */ G(function(r, i) {
	let { __scopeRovingFocusGroup: a, orientation: o, loop: s = !1, dir: l, currentTabStopId: u, defaultCurrentTabStopId: d, onCurrentTabStopIdChange: f, onEntryFocus: p, preventScrollOnEntryFocus: m = !1, ...h } = r, g = t.useRef(null), _ = c(i, g), v = H(l), [y, b] = V({
		prop: u,
		defaultProp: d ?? null,
		onChange: f,
		caller: q
	}), [x, S] = t.useState(!1), C = L(p), w = Le(a), T = t.useRef(!1), [ee, E] = t.useState(0);
	return t.useEffect(() => {
		let e = g.current;
		if (e) return e.addEventListener(K, C), () => e.removeEventListener(K, C);
	}, [C]), /* @__PURE__ */ n(Ve, {
		scope: a,
		orientation: o,
		dir: v,
		loop: s,
		currentTabStopId: y,
		onItemFocus: t.useCallback((e) => b(e), [b]),
		onItemShiftTab: t.useCallback(() => S(!0), []),
		onFocusableItemAdd: t.useCallback(() => E((e) => e + 1), []),
		onFocusableItemRemove: t.useCallback(() => E((e) => e - 1), []),
		children: /* @__PURE__ */ n(O.div, {
			tabIndex: x || ee === 0 ? -1 : 0,
			"data-orientation": o,
			...h,
			ref: _,
			style: {
				outline: "none",
				...r.style
			},
			onMouseDown: e(r.onMouseDown, () => {
				T.current = !0;
			}),
			onFocus: e(r.onFocus, (e) => {
				let t = !T.current;
				if (e.target === e.currentTarget && t && !x) {
					let t = new CustomEvent(K, Ie);
					if (e.currentTarget.dispatchEvent(t), !t.defaultPrevented) {
						let e = w().filter((e) => e.focusable);
						X([
							e.find((e) => e.active),
							e.find((e) => e.id === y),
							...e
						].filter(Boolean).map((e) => e.ref.current), m);
					}
				}
				T.current = !1;
			}),
			onBlur: e(r.onBlur, () => S(!1))
		})
	});
}, "RovingFocusGroupImpl")), Ge = "RovingFocusGroupItem", Ke = /* @__PURE__ */ t.forwardRef(/* @__PURE__ */ G(function(r, i) {
	let { __scopeRovingFocusGroup: a, focusable: o = !0, active: s = !1, tabStopId: c, children: l, ...u } = r, d = I(), f = c || d, p = He(Ge, a), m = p.currentTabStopId === f, h = Le(a), { onFocusableItemAdd: g, onFocusableItemRemove: _, currentTabStopId: v } = p, y = Pe();
	return F(() => {
		if (!(!y || !o)) return g(), () => _();
	}, [
		y,
		o,
		g,
		_
	]), t.useEffect(() => {
		if (!(y || !o)) return g(), () => _();
	}, [
		y,
		o,
		g,
		_
	]), /* @__PURE__ */ n(J.ItemSlot, {
		scope: a,
		id: f,
		focusable: o,
		active: s,
		children: /* @__PURE__ */ n(O.span, {
			tabIndex: m ? 0 : -1,
			"data-orientation": p.orientation,
			...u,
			ref: i,
			onMouseDown: e(r.onMouseDown, (e) => {
				o ? p.onItemFocus(f) : e.preventDefault();
			}),
			onFocus: e(r.onFocus, () => p.onItemFocus(f)),
			onKeyDown: e(r.onKeyDown, (e) => {
				if (e.key === "Tab" && e.shiftKey) {
					p.onItemShiftTab();
					return;
				}
				if (e.target !== e.currentTarget) return;
				let t = Y(e, p.orientation, p.dir);
				if (t !== void 0) {
					if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
					e.preventDefault();
					let n = h().filter((e) => e.focusable).map((e) => e.ref.current);
					if (t === "last") n.reverse();
					else if (t === "prev" || t === "next") {
						t === "prev" && n.reverse();
						let r = n.indexOf(e.currentTarget);
						n = p.loop ? Ye(n, r + 1) : n.slice(r + 1);
					}
					setTimeout(() => X(n));
				}
			}),
			children: typeof l == "function" ? l({
				isCurrentTabStop: m,
				hasTabStop: v != null
			}) : l
		})
	});
}, "RovingFocusGroupItem")), qe = {
	ArrowLeft: "prev",
	ArrowUp: "prev",
	ArrowRight: "next",
	ArrowDown: "next",
	PageUp: "first",
	Home: "first",
	PageDown: "last",
	End: "last"
};
function Je(e, t) {
	return t === "rtl" ? e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e : e;
}
G(Je, "getDirectionAwareKey");
function Y(e, t, n) {
	let r = Je(e.key, n);
	if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r))) return qe[r];
}
G(Y, "getFocusIntent");
function X(e, t = !1) {
	let n = document.activeElement;
	for (let r of e) if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
G(X, "focusFirst");
function Ye(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
G(Ye, "wrapArray");
var Xe = Ue, Ze = Ke, Qe = Object.defineProperty, Z = (e, t) => Qe(e, "name", {
	value: t,
	configurable: !0
});
function $e(e, n) {
	return t.useReducer((e, t) => n[e][t] ?? e, e);
}
Z($e, "useStateMachine");
var et = /* @__PURE__ */ Z((e) => {
	let { present: n, children: r } = e, i = tt(n), a = typeof r == "function" ? r({ present: i.isPresent }) : t.Children.only(r), o = nt(i.ref, rt(a));
	return typeof r == "function" || i.isPresent ? t.cloneElement(a, { ref: o }) : null;
}, "Presence");
function tt(e) {
	let [n, r] = t.useState(), i = t.useRef(null), a = t.useRef(e), o = t.useRef("none"), s = t.useRef(void 0), [c, l] = $e(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return t.useEffect(() => {
		c === "mounted" ? (o.current = s.current ?? $(i.current), s.current = void 0) : o.current = "none";
	}, [c]), F(() => {
		let t = i.current, n = a.current;
		if (n !== e) {
			let r = o.current, i = $(t);
			e ? (s.current = i, l("MOUNT")) : i === "none" || t?.display === "none" ? l("UNMOUNT") : l(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
		}
	}, [e, l]), F(() => {
		if (n) {
			let e, t = n.ownerDocument.defaultView ?? window, r = /* @__PURE__ */ Z((r) => {
				let o = $(i.current).includes(CSS.escape(r.animationName));
				if (r.target === n && o && (l("ANIMATION_END"), !a.current)) {
					let r = n.style.animationFillMode;
					n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
						n.style.animationFillMode === "forwards" && (n.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ Z((e) => {
				e.target === n && (o.current = $(i.current));
			}, "handleAnimationStart");
			return n.addEventListener("animationstart", s), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
				t.clearTimeout(e), n.removeEventListener("animationstart", s), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
			};
		} else l("ANIMATION_END");
	}, [n, l]), {
		isPresent: ["mounted", "unmountSuspended"].includes(c),
		ref: t.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				i.current = t, s.current = $(t);
			} else i.current = null;
			r(e);
		}, [])
	};
}
Z(tt, "usePresence");
function Q(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Z(Q, "setRef");
function nt(...e) {
	let n = t.useRef(e);
	return n.current = e, t.useCallback((e) => {
		let t = n.current, r = !1, i = t.map((t) => {
			let n = Q(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let n = i[e];
				typeof n == "function" ? n() : Q(t[e], null);
			}
		};
	}, []);
}
Z(nt, "useStableComposedRefs");
function $(e) {
	return e?.animationName || "none";
}
Z($, "getAnimationName");
function rt(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Z(rt, "getElementRef");
//#endregion
export { H as a, F as c, c as d, Be as i, O as l, Ze as n, V as o, Xe as r, I as s, et as t, f as u };

//# sourceMappingURL=dist-BBT9ugBv.js.map